import React, { useCallback, useMemo, useState } from 'react';

import { connect, useDispatch, useSelector } from 'react-redux';
// import { useMediaQuery } from 'react-responsive';

import { isEqual } from 'lodash';

import { menuHighlightDefaultColor } from 'consts';
// import configs from 'configs';
import { EVENT_TYPE, trackEventByType } from 'gaTracking';
import { ensureSubscriptionData, switchControlMode } from 'utils';

// import { ShareIcon } from 'components/icons';
import { useNavigatedRoutes } from 'common/hooks';
import Compass from 'components/Compass';
import './style.scss';

import {
  setMenuPosition,
  toggleAudio,
  toggleMenu,
  togglePanoMode,
  setControlMode,
} from 'store/actions';

// import MenuForMobile from 'components/MenuForMobile';
// import MenuForDesktop from 'components/MenuForDesktop';
import { LAYOUT_UI } from 'consts/ui.const';
import HOTSPOT_TYPE from 'consts/hotspotType.const';
import MEDIA_TYPE from 'consts/mediaType.const';
// import LaritaLayout from 'components/LatiraLayout';
// import MenuSocial from './MenuSocial';
// import MenuBottom from './MenuBottom';
// import MenuActions from './MenuActions';
import LevelSwitch from 'components/LevelSwitch/LevelSwitch';
// import MenuTop from 'components/Menu';
import MapFloorPlan from 'components/MapFloorPlan';
// import MenuTop from 'components/Menu';
// import AquaLayout from 'components/AquaLayoutV2/AquaLayout';
// import AvoriazLayout from 'components/AvoriazLayout';
// import MobiHomeLayout from 'components/MobiHomeLayout';
// import ClearSpaceLayout from 'components/ClearSpaceLayout';
// import ResortLayout from 'components/ResortLayout';

const DEFAUlt_MAP_COORDINATES = [0, 0, 10];
// const INDOORSCENES = [
//   'can-ho-1',
//   'can-ho-2',
//   'can-ho-3',
//   'can-ho-4',
//   'can-ho-5',
//   'can-ho-6',
//   'can-ho-7',
//   'can-ho-8',
//   'can-ho-9',
//   'can-ho-10',
//   'can-ho-11',
// ];


function moveItemToTop(arr, targetId) {
  arr.sort((a, b) => b.objects.length - a.objects.length);

  const index = arr.findIndex((item) => {
    return item.objects.some((obj) => obj.id === targetId);
  });

  if (index !== -1) {
    const itemToMove = arr.splice(index, 1)[0];
    arr.unshift(itemToMove);
  }

  return arr;
}

const MenuV2 = (props) => {
  // eslint-disable-next-line
  const {
    // logoURL,
    // hasLogo,
    // isSchoolLayout,
    // isAquaStyle,
    // isAvoriazStyle,
    // isMobihomeStyle,
    // isClearSpaceStyle,
    // isResortStyle,
  } = useSelector((state) => ({
    logoURL: state.logoURL,
    hasLogo: state.hasLogo,
    isSchoolLayout: state.tour.menuStyle === LAYOUT_UI.SCHOOL,
    isAquaStyle: state.tour.menuStyle === LAYOUT_UI.AACORPORATION,
    isAvoriazStyle: state.tour.menuStyle === LAYOUT_UI.AVORIAZ,
    isMobihomeStyle: state.tour.menuStyle === LAYOUT_UI.MOBIHOME,
    isClearSpaceStyle: state.tour.menuStyle === LAYOUT_UI.CLEAR_SPACE,
    isResortStyle: state.tour.menuStyle === LAYOUT_UI.RESORT,
  }));
  // eslint-disable-next-line
  // const [isActive, setIsActive] = useState(false);
  const [openMenu] = useState(!(props.tour.menuStyle === LAYOUT_UI.SCHOOL));

  const enableBranding = useSelector(
    ({ subscriptionPlan }) => subscriptionPlan.enableBranding
  );
  const menuHighlightColor = props.json.tour.menuHighlightColor;

  const dispatch = useDispatch();
  // eslint-disable-next-line
  const [handleUpdateRoute] = useNavigatedRoutes();
  // eslint-disable-next-line
  const menuOpenScene = (gId, sId) => {
    props.onSelect(gId, sId);
    trackEventByType(EVENT_TYPE.SCENE_FROM_MENU, sId);
  };
  const { controlMode } = useSelector((state) => state);
  // eslint-disable-next-line
  const handleSwitchControlMode = useCallback(async () => {
    const switchToMode = await switchControlMode(controlMode);
    if (switchToMode !== controlMode) dispatch(setControlMode(switchToMode));
  }, [controlMode, dispatch]);

  // eslint-disable-next-line
  const isShowOnMap = useMemo(
    () => !isEqual(props.tourMapCoordinates, DEFAUlt_MAP_COORDINATES),
    [props.tourMapCoordinates]
  );
  // eslint-disable-next-line
  const hightLightColor = useMemo(
    () => (enableBranding ? menuHighlightColor : menuHighlightDefaultColor),
    [enableBranding, menuHighlightColor]
  );
  // eslint-disable-next-line
  const isShowAudioIcon = useMemo(() => props.audio.available, [props.audio]);

  const floorMaps = useMemo(() => {
    const mapFloorPlansInHotspot =
      props?.currentPano?.hotspots?.reduce((plans, hs) => {
        let mapPlansInCurrentHotspot = [];
        // get mapFloorPlan array in hotspot OR in media object
        if (
          hs?.type === HOTSPOT_TYPE.MEDIA &&
          hs?.media?.type === MEDIA_TYPE.MAPFLOORPLAN &&
          hs?.media?.mapFloorPlan?.length
        ) {
          mapPlansInCurrentHotspot = hs.media.mapFloorPlan;
        } else if (
          hs?.type === HOTSPOT_TYPE.MAP_FLOOR_PLAN &&
          hs?.mapFloorPlan?.length
        ) {
          mapPlansInCurrentHotspot = hs.mapFloorPlan;
        }

        // get unique floorplan
        const filterMapPlansInCurrentHotspot = mapPlansInCurrentHotspot.reduce(
          (plansInHs, currPlan) => {
            const existed = plans.find(
              (plan) =>
                plan.image.name === currPlan.image.name &&
                plan.image.url === currPlan.image.url
            );
            if (!existed) {
              plansInHs.push(currPlan);
            }
            return plansInHs;
          },
          []
        );

        return plans.concat(filterMapPlansInCurrentHotspot);
      }, []) || [];

    return moveItemToTop(mapFloorPlansInHotspot, props.currentPano?._id);
  }, [props.currentPano]);
  // eslint-disable-next-line
  const isShowMapFloorPlan = useMemo(
    () => !!floorMaps.length || props?.currentPano?.isShowMapFloorPlan,
    [floorMaps.length, props?.currentPano?.isShowMapFloorPlan]
  );

  // const isRenderFloorButtons = useMemo(() => {
  //   return INDOORSCENES.some((item) => item === props.currentPano?.id);
  // }, [props.currentPano]);

  return (
    <>
      {/* <MenuBottom
        currentPano={props.currentPano}
        onSelect={props.onSelect}
        isActive={isActive}
        setIsActive={setIsActive}
        isRenderFloorButtons={isRenderFloorButtons}
        menuActions={() => (
          <MenuActions
            menuOpenScene={menuOpenScene}
            handleSwitchControlMode={handleSwitchControlMode}
            color={hightLightColor}
            isShowOnMap={isShowOnMap}
            isShowAudioIcon={isShowAudioIcon}
            floorMaps={floorMaps}
            isShowMapFloorPlan={isShowMapFloorPlan}
            openMenu={openMenu}
            setOpenMenu={setOpenMenu}
            isAquaStyle={isAquaStyle}
            setIsActive={setIsActive}
            isRenderFloorButtons={isRenderFloorButtons}
            {...props}
          />
        )}
      /> */}

      {/* <MenuSocial /> */}

      <MapFloorPlan
        currentPano={props.currentPano}
        floorMaps={floorMaps}
        onSelect={props.onSelect}
      />

      {props.showWorld3D && (
        <Compass
          currentPano={props.currentPano}
          cameraParams={props.cameraParams}
          sceneRotation={props.sceneRotation}
        />
      )}

      {props.showWorld3D && (
        <LevelSwitch
          currentPano={props.currentPano}
          onSelect={props.onSelect}
          openMenu={openMenu}
        />
      )}
    </>
  );
};

const mapStateToProps = ({
  dimentions,
  menu,
  audio,
  json,
  currentScene,
  tour,
}) => ({
  dimentions,
  isNavOpen: menu.isOpen,
  menuPosition: menu.position,
  mapPopupOpen: menu.isoMetricMap,
  socialPopupOpen: menu.social,
  audio,
  json,
  featured: json.featured,
  featuredMedia: json.featuredMedia,
  tourMapCoordinates: json.tour.mapCoordinates,
  showOnMap: currentScene.showOnMap,
  scope: ensureSubscriptionData(tour.subscriptionPlan.scopes),
  tour,
});

const mapDispatchToProps = {
  toggleMenu,
  togglePanoMode,
  setMenuPosition,
  toggleAudio,
};

export default connect(mapStateToProps, mapDispatchToProps)(MenuV2);
